import { Delimiter } from '@otp/ui';
import styles from './index.module.css';

type ActionBarWrapperProps = {
  children: React.ReactNode;
};

export const ActionBarWrapper = ({ children }: ActionBarWrapperProps) => {
  return (
    <>
      <Delimiter className="mt-4" />
      <div className={styles.actionBarWrapper}>{children}</div>
    </>
  );
};
